// extracted by mini-css-extract-plugin
export default {"langSelector":"style_langSelector__NOCgg"};